import { render, staticRenderFns } from "./FullIconButtonView.vue?vue&type=template&id=0bfe6912&scoped=true&"
import script from "./FullIconButtonView.vue?vue&type=script&lang=js&"
export * from "./FullIconButtonView.vue?vue&type=script&lang=js&"
import style0 from "./FullIconButtonView.vue?vue&type=style&index=0&id=0bfe6912&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe6912",
  null
  
)

export default component.exports